import { produce } from "immer";
import {
  SET_ANALYTICS_FILTER_OPTIONS,
  SET_LINE_GLASS_MODEL,
  OVERVIEW_DATA,
  GLASS_ARRAY,
  VAR_ARRAY,
} from "../actionType";

const INIT_STATE = {
  filterOptions: {
    line: "",
    glass: "",
    variant: "",
  },
  lineList: [],
  glassList: [],
  modelList: [],
  overview: {
    uniqueUser: 0,
    newUser: 0,
    sessions: 0,
    avgTime: 0,
  },
  glassArray: {},
  variantArray: {},
};

const analyticsReducer = (state = INIT_STATE, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_ANALYTICS_FILTER_OPTIONS:
        // Serializza i valori delle opzioni di filtro
        if (action.options) {
          const serializedOptions = { ...action.options };

          // Controlla se glass è un riferimento a un documento
          if (serializedOptions.glass) {
            if (typeof serializedOptions.glass === 'object' && serializedOptions.glass !== null) {
              // Se ha un id, usa solo quello
              if (serializedOptions.glass.id) {
                serializedOptions.glass = serializedOptions.glass.id;
              } else if (serializedOptions.glass.type === 'document' && serializedOptions.glass.firestore) {
                // È un riferimento a documento di Firestore
                serializedOptions.glass = serializedOptions.glass.id || '';
              }
            }
          }

          // Controlla se variant è un riferimento a un documento
          if (serializedOptions.variant) {
            if (typeof serializedOptions.variant === 'object' && serializedOptions.variant !== null) {
              // Se ha un id, usa solo quello
              if (serializedOptions.variant.id) {
                serializedOptions.variant = serializedOptions.variant.id;
              } else if (serializedOptions.variant.type === 'document' && serializedOptions.variant.firestore) {
                // È un riferimento a documento di Firestore
                serializedOptions.variant = serializedOptions.variant.id || '';
              }
            }
          }

          draft.filterOptions = serializedOptions;
        } else {
          draft.filterOptions = INIT_STATE.filterOptions;
        }
        break;
      case SET_LINE_GLASS_MODEL:
        draft.lineList = action.payload.lineList || [];
        draft.glassList = action.payload.glassList || [];
        draft.modelList = action.payload.modelList || [];
        break;
      case OVERVIEW_DATA:
        draft.overview = {
          ...draft.overview,
          ...action.payload,
        };
        break;
      case GLASS_ARRAY:
        draft.glassArray = {
          ...draft.glassArray,
          ...action.payload,
        };
        break;
      case VAR_ARRAY:
        draft.variantArray = {
          ...draft.variantArray,
          ...action.payload,
        };
        break;
      default:
        break;
    }
  });

export default analyticsReducer;